var TabAttachmentsModule = /** @class */ (function () {
    function TabAttachmentsModule() {
    }
    return TabAttachmentsModule;
}());
export { TabAttachmentsModule };
